import { useDispatch, useSelector } from 'react-redux';
import { UseFormReset } from 'react-hook-form/dist/types';

import {
  getOnboardingActive,
  getOnboardingIsSecondStep,
  getOnboardingPaymentPath
} from '@epi-store/onboarding/onboarding.selectors';
import { useOnboardingWizard } from '@epi-shared/hooks/useOnboardingWizard';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { onboardingActions } from '@epi-store/onboarding/onboarding.slice';
import { TopupFormType } from '@epi-pages/LoadBenefit/components/Topup/TopupForm';

export const useOnboardingPayment = (
  resetForm?: UseFormReset<TopupFormType>
) => {
  const { isOnBoardingActive } = useOnboardingWizard();
  const dispatch = useDispatch();

  let paymentPath = useSelector(getOnboardingPaymentPath);
  const isPaymentActive = useSelector(getOnboardingActive);
  const isSecondStep = useSelector(getOnboardingIsSecondStep);

  const redirect = (path: string) => {
    dispatch(goToPage(path));
  };

  const handleNextPageForDirectLoadMultiple = () => {
    if (isSecondStep) {
      dispatch(onboardingActions.setIsSecondStepDisplayed(false));
      dispatch(onboardingActions.setOnboardingInProgress(false));
      redirect(routerPaths.onboardingFinished);
      return;
    }

    resetForm?.();
    dispatch(onboardingActions.setLoadBenefitPageType('others'));
    dispatch(onboardingActions.setIsSecondStepDisplayed(true));
  };

  if (!isOnBoardingActive && !isPaymentActive) {
    return;
  }

  if (paymentPath === 'directLoadNoLounari') {
    return {
      onboardingLoadBenefit: {
        onNext: () => redirect(routerPaths.onboardingFinished),
        onBack: () => redirect(routerPaths.beneficiaries)
      }
    };
  }

  if (paymentPath === 'topupOnlyLounari') {
    return {
      onboardingTransferMoney: {
        onNext: () => redirect(routerPaths.onboardingFinished),
        onBack: () => redirect(routerPaths.beneficiaries)
      }
    };
  }

  if (paymentPath === 'topupMultiple') {
    return {
      onboardingLoadBenefit: {
        onNext: () => {
          dispatch(onboardingActions.setIsSecondStepDisplayed(true));
          redirect(routerPaths.loadCompanyAccount);
        },
        onSkip: () => {
          dispatch(onboardingActions.setIsSecondStepDisplayed(true));
          redirect(routerPaths.loadCompanyAccount);
        },
        onBack: () => redirect(routerPaths.beneficiaries)
      },
      onboardingTransferMoney: {
        onNext: () => redirect(routerPaths.onboardingFinished),
        onSkip: () => redirect(routerPaths.onboardingFinished),
        onBack: () => {
          dispatch(onboardingActions.setIsSecondStepDisplayed(false));
          redirect(routerPaths.loadBenefit);
        }
      }
    };
  }

  if (paymentPath === 'directLoadOnlyLounari') {
    return {
      onboardingLoadBenefit: {
        onNext: () => redirect(routerPaths.onboardingFinished),
        onBack: () => redirect(routerPaths.beneficiaries)
      }
    };
  }

  if (paymentPath === 'directLoadMultiple') {
    return {
      onboardingLoadBenefit: {
        onNext: handleNextPageForDirectLoadMultiple,
        onSkip: handleNextPageForDirectLoadMultiple,
        onBack: () => {
          if (isSecondStep) {
            resetForm?.();
            dispatch(onboardingActions.setLoadBenefitPageType('lounari'));
            dispatch(onboardingActions.setIsSecondStepDisplayed(false));
            return;
          }

          redirect(routerPaths.beneficiaries);
        }
      }
    };
  }
};
